<template>
  <div id="vmain" class="container-fluid" style="padding-right: 1.5rem; padding-left: 1.5rem;">

    <div class="navbar bd-navbar flex-column flex-md-row navbar-dark navbar-expand"
      v-bind:style="{'display': headerDisplay}" style="height:14rem;">
      <vHeader :pageInfo=pageInfo @toggle="toggle" @getDefaultMenu="getDefaultMenu" />
    </div>

    <div class="container-fluid" style="padding-right: 0; padding-left: 0; ">
      <b-row>
        <b-col lg="3" aria-controls="overlay-background" style="padding-right: 5px; padding-left: 15px; ">
          <div class="well" style="padding: 1rem;" v-bind:class="curBg">
            <table style="text-align: left; width:100%;"
              v-if="(pageInfo!=null) && (0 < pageInfo.length)">
              <tbody
                  v-for="(it, index) in pageInfo[0].subMenu"  :key="it.menuNo"
                  :index="it.menuNo" :name="it.menuNo">
                <tr style="font-weight: bolder;" >
                  <td v-bind:class="curBtn"
                      @click="it.sysId=(0 < it.sysId? 0: 1)"
                       style="color:#481e1c; padding: 0.25rem 1rem 0;">{{it.title[curLang]}}&nbsp;&nbsp;<b-icon class="border rounded" variant="dark" v-bind:class="curIcon"
                      scale="0.75" shift-v="-0.25"
                      rotate="15"
                      shift-h="-6"
                      :icon="it.content" font-scale="1.5" v-if="null != it.content && 0< it.content.length" /></td>
                </tr>
                <tr v-for="(node0,dtIndex) in it.subMenu" :key="node0.menuNo"
                  :index="node0.menuNo" :name="node0.menuNo">
                  <td style="padding: 0.25rem 0 0 2rem;" v-bind:class="curBtn"
                    @click="toggle(index, dtIndex)"
                    v-if="0 < it.sysId">
                    {{node0.title[curLang]}}&nbsp;&nbsp;<b-icon class="border rounded" variant="dark" v-bind:class="curIcon"
                      scale="0.75" shift-v="-0.25"
                      rotate="15"
                      shift-h="-6" :icon="node0.content" font-scale="1.5"
                      v-if="null != node0.content && 0< node0.content.length"/>
                  </td>
                </tr>
              </tbody>
              <tr>
                <td style="padding: 1rem;">
                  <b-button size="sm" class="my-2 my-sm-0" type="submit" style="color:#30161c; font-weight: bolder; font-size: larger;" variant="warning"
                    @click.prevent="logout()"
                    v-if="user.isInit"><b-icon icon="door-closed"></b-icon>{{$t('message.Sign_Out')}}</b-button>
                </td>
              </tr>
            </table>
            <div v-else>
              <span style="color: red;">無可執行的功能〜</span>
              <b-button size="sm" class="my-2 my-sm-0" type="submit" style="color:#30161c; font-weight: bolder; font-size: larger;" variant="warning"
                    @click.prevent="logout()"
                    v-if="user.isInit"><b-icon icon="door-closed"></b-icon>{{$t('message.Sign_Out')}}</b-button>
            </div>
          </div>
        </b-col>

        <b-col lg="9" style="padding-right: 15px; padding-left: 5px;">
          <b-container>
            <vTitle :pageInfo=pageInfo :curLang=curLang @toggle="toggle" />
            <component class="container well" style="background: transparent; padding: 0.25rem;"
              v-bind:is="currentComponent" @getDefaultMenu="getDefaultMenu" ></component>
          </b-container>
        </b-col>
      </b-row>

      <b-row style="text-align: right; font-size: 12px; background: transparent;">
        <b-col>
          <vFooter :pageInfo=pageInfo />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import i18n from '@/i18n/lang'
import vHeader from '@/components/common/HeaderView.vue'
import vTitle from '@/components/common/TitlePage.vue'
import vFooter from '@/components/common/FooterView.vue'
import * as tools from '../tool'
export default {
  name: 'vmain',
  props: ['init'],
  components: {
    i18n, vHeader, vTitle, vFooter
  },
  data () {
    return {
      pageInfo: null,
      currentComponent: '',
      curLang: 0,
      jsData: [],
      isIE: false
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    user () {
      return this.$store.getters.getUser
    },
    headerDisplay () {
      return (this.isIE ? 'ruby' : 'contents')
    },
    menuId () {
      return (this.$store.getters.getPageId >= 0 ? '1-'.concat(this.$store.getters.getPageId) : '')
    },
    setting () {
      return this.$store.getters.getSetting
    },
    headerColor () {
      let url = 'warning'
      if (this.setting != null && this.setting.bgColor != null && this.setting.bgColor[0] != null && this.setting.bgColor[0].codeName.length > 0) {
        url = this.setting.bgColor[0].codeName
      }
      return url
    },
    curBg () {
      let url = 'bg-warning'
      if (this.setting != null && this.setting.bgColor != null && this.setting.bgColor[0] != null && this.setting.bgColor[0].codeName.length > 0) {
        url = tools.stringFormat('bg-{0}', this.setting.bgColor[0].codeName)
      }
      return url
    },
    curBtn () {
      let url = 'btn-warning'
      if (this.setting != null && this.setting.bgColor != null && this.setting.bgColor[0] != null && this.setting.bgColor[0].codeName.length > 0) {
        url = tools.stringFormat('btn-{0}', this.setting.bgColor[0].codeName)
      }
      return url
    },
    curIcon () {
      let url = 'border-warning'
      if (this.setting != null && this.setting.bgColor != null && this.setting.bgColor[0] != null && this.setting.bgColor[0].codeName.length > 0) {
        url = tools.stringFormat('border-{0}', this.setting.bgColor[0].codeName)
      }
      return url
    }
  },
  methods: {
    setFlag (it) {
      if (tools.isNull(this.pageInfo[0].subMenu[it].flag)) {
        this.pageInfo[0].subMenu[it].flag = true
      } else {
        this.pageInfo[0].subMenu[it].flag = !this.pageInfo[0].subMenu[it].flag
      }
    },
    setLang (newLang) {
      i18n.locale = newLang
      localStorage.setItem('locale', newLang)
    },
    handleClick (tab, event) {
      this.toggle(0, tab.index)
    },
    logout: function () {
      if (this.user.mode == 'S') {
        this.$store.dispatch('resetUser')
        this.getDefaultMenu(this.sysId, false)
        this.$router.push({ path: 'main' })
      } else {
        var user = {
          id1: this.$store.state.user.id,
          id2: '',
          id3: '',
          isLogin: false,
          sysId: this.sysId
        }
        var vm = this
        this.$http.put('./WebApi/Common/Authorized', user)
          .then((response) => {
            if (response.data != null) {
              vm.$store.dispatch('resetLogin')
              vm.idleTime = 0
              vm.$router.push({ path: '/login' })
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
          })
      }
    },
    toggle: function (appId, pageId) {
      if (appId == -1 && pageId == -1) {
        this.$store.dispatch('actionAppId', -1)
        this.$store.dispatch('actionPageId', -1)
        // this.setCurComp('Billboard');
      } else if (appId == -2 && pageId == -2) {
        this.$store.dispatch('actionAppId', -2)
        this.$store.dispatch('actionPageId', -2)
        this.setCurComp('Help')
      } else if (appId == -3 && pageId == -3) {
        this.$store.dispatch('actionAppId', -3)
        this.$store.dispatch('actionPageId', -3)
        this.setCurComp('Login')
      } else if (appId == -4 && pageId == -4) {
        this.$store.dispatch('actionAppId', -4)
        this.$store.dispatch('actionPageId', -4)
        this.setCurComp('Warning')
      } else {
        this.$store.dispatch('actionAppId', appId)
        this.$store.dispatch('actionPageId', pageId)
        if (!tools.isNull(this.pageInfo) &&
            (appId < this.pageInfo[0].subMenu.length)) {
          this.setCurComp(this.pageInfo[0].subMenu[appId].subMenu[pageId].path)
        }
      }
      this.setPageTitle()
    },
    setPageTitle: function () {
      let url = ''
      if ((this.pageInfo != null) &&
          (appId < this.pageInfo.length) &&
          (this.$store.getters.getAppId > -1) &&
          (this.$store.getters.getPageId > -1)) {
        var appId = this.$store.getters.getAppId
        var pageId = this.$store.getters.getPageId
        url = this.pageInfo[0].subMenu[appId].subMenu[pageId].title[this.curLang]
      }
      // console.log('======url===== :' + url)
      this.$store.dispatch('setSysTitle', url)
    },
    setCurComp: function (evtValue) {
      // this.currentComponent = evtValue
      if (evtValue !== null) {
        this.currentComponent = evtValue
      } else {
        this.currentComponent = 'Help'
      }
    },
    capitalizeFirstLetter: function (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    setComponent: function () {
      const cFlag = false
      const appId = 0; const pageId = 0; const sort = -1
      if ((this.pageInfo != null) &&
          (this.pageInfo.length > 0) &&
          (this.pageInfo[0].subMenu != null)) {
        var len = this.pageInfo[0].subMenu.length
        var vm = this
        const requireComponent = require.context('../components', true, /\.vue$/)
        requireComponent.keys().forEach(fileName => {
          const componentConfig = requireComponent(fileName)
          const componentName = this.capitalizeFirstLetter(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
          var index = vm.jsData.indexOf(componentName)

          if (index < 0) {
            if (componentName === 'HelpView') {
              Vue.component('Help', componentConfig.default || componentConfig)
              vm.jsData.push(componentName)
            } else if (componentName === 'BillboardView') {
              Vue.component('Billboard', componentConfig.default || componentConfig)
              vm.jsData.push(componentName)
            } else if (componentName === 'LoginView') {
              Vue.component('Login', componentConfig.default || componentConfig)
              vm.jsData.push(componentName)
            } else if (componentName === 'WarningView') {
              Vue.component('Warning', componentConfig.default || componentConfig)
              vm.jsData.push(componentName)
            } else {
              var found = false
              for (var i = 0; i < len && !found; i++) {
                if (!tools.isNull(vm.pageInfo[0].subMenu[i].subMenu)) {
                  var jLen = vm.pageInfo[0].subMenu[i].subMenu.length
                  for (var j = 0; j < jLen && !found; j++) {
                    if (vm.pageInfo[0].subMenu[i].subMenu[j].jsPath === componentName) {
                      console.log('MainView: componentName=' + componentName + ' path:' + vm.pageInfo[0].subMenu[i].subMenu[j].path)
                      Vue.component(vm.pageInfo[0].subMenu[i].subMenu[j].path, componentConfig.default || componentConfig)
                      vm.jsData.push(componentName)
                      found = true
                    }
                  }
                }
              }
            }
          }
        })
      }
    },
    getDefaultMenu: function (sId, flag) {
	    var vm = this
      if (!flag || (this.pageInfo == null)) {
        var status = (this.user.status == null ? 0 : this.user.status)
        this.$http
          .get('./WebApi/Common/GetMenuItemByLang/'.concat(this.sysId).concat('/').concat(status).concat('/1'))
          .then(function (response) {
            vm.pageInfo = response.data
            vm.setComponent()
            vm.toggle(-1, -1)
          })
      }
    }
  },
  created () {
    console.log('======created=====MainView')
    var userAgent = navigator.vendor
    this.isIE = navigator.userAgent.indexOf('MSIE ') > -1 || navigator.userAgent.indexOf('Trident/') > -1
    if (this.sysId > 0) {
      this.getDefaultMenu(this.sysId, true)
    }
  },
  watch: {
    sysId (newId, oldId) {
      // console.log('======watch sysId====='+newId)
      if (newId != oldId) {
        this.getDefaultMenu(newId, true)
      }
    },
    init (val, oldVal) {
      // console.log('======watch init====='+val)
      if (val != oldVal) {
        this.getDefaultMenu(this.sysId, false)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

.navbar-dark .navbar-nav .nav-link:hover {
    color: rgba(238, 247, 242, 0.85);
    font-weight: bolder;
}

.navbar-dark .navbar-nav .nav-link:focus {
    color: rgba(238, 247, 242, 0.95);
    font-weight: bolder;
    font-size: large;
}

.menu-text {
  cursor: pointer;
  text-decoration: none;
  background-color: transparent;
  color: #131124;
}
.bg-primary {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
}
.bg-secondary {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d;
}
.bg-success {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745;
}
.bg-warning {
    color: #212529;
    background-color: #ffc107;
    border-color: #ffc107;
}
.bg-info {
    color: #fff;
    background-color: #17a2b8;
    border-color: #17a2b8;
}
.bg-light {
    color: #212529;
    background-color: #f8f9fa;
    border-color: #f8f9fa;
}
.bg-dark {
    color: #fff;
    background-color: #343a40;
    border-color: #343a40;
}
</style>
